import router from "../router/index";
import axios from "axios";
import { Error } from "../utils/Error";
import { EventBus } from "../event-bus";

export class Token {
    //get from memory "token". if token expiry>now token not expired 
    //else if expiry<now token expired refreshtoken
    //refreshtoken will refresh both token and refreshtoken
    //if null(!newToken) then 1 hour has passed 
    public static async getTokenWithExpiry(key: string) {
        console.log("getTokenWithExpiry");
        const itemStr = localStorage.getItem(key);

        if (!itemStr) {
            console.log("getTokenWithExpiry returns null");
            router.push({ name: "Login" });
            return;
        }
        const item = JSON.parse(itemStr);
        console.log("token item",item)//value: 'ey...Jh.ey...Q.D...g', expiry: 1642689634
        let now = new Date().getTime() / 1000;
        now = Math.floor(now);

        // compare the expiry time of the token with the current time
        if (now > item.expiry) {
            console.log("TOKEN EXPIRED");
            localStorage.removeItem(key);
            await this.refreshToken();
            const newToken = localStorage.getItem("token");

            if (!newToken) {
                console.log("getTokenWithExpiry returns null when Generate new Token");
                return null;
            }

            const newItem = JSON.parse(newToken);
            console.log("token newitem ",newItem)
            return newItem.value;
        } else {
            console.log("TOKEN NOT EXPIRED");
            return item.value;
        }
    }

    //input: "token",response.data.accessToken,+response.data.exp,response.data.refreshToken
    //output: response.data.accessToken,response.data.exp
    public static setTokenWithExpiry(
        key: string,
        value: string,
        ttl: number,
        type: number,
        refreshToken: string
    ) {
        console.log("-- setTokenWithExpiry --");
        const now = new Date();

        const addExtraseconds = ttl - now.getTime();
        const item = {
            value: value,            
            type:type,
            expiry: now.getTime() + addExtraseconds//edw na balw to type
        };

        localStorage.setItem(key, JSON.stringify(item));
        localStorage.setItem("refreshToken", refreshToken);
    }

    //get from memory "refreshtoken". it will call backend to validate. backend will answer if expiry>now
    //if back answers refreshtoken will refresh both token and refreshtoken
    //if null(!newToken) then 1 hour has passed 
    private static async refreshToken() {
        const refreshToken = localStorage.getItem("refreshToken");
        console.log("refreshToken call with value of refreshToken:", refreshToken);
        ////EventBus.$emit("BeginLoader",null );   

        await axios({
            method: "post",
            url: `${process.env.VUE_APP_BASE_URL}/refreshToken`,
            withCredentials: true,
            data: {
                refreshToken: refreshToken
            }
        })
            .then(response => {
                console.log("success response of refreshToken:", response);
                this.setTokenWithExpiry(
                    "token",
                    response.data.accessToken,
                    +response.data.exp,
                    response.data.type,
                    response.data.refreshToken
                );
            })
            .catch(err => {
                console.log("error on refreshToken:", err);
                Token.removeTokens();
                Error.handleError(err);
                router.push({ name: "Login" });
            });
    }

    public static removeTokens() {
        localStorage.removeItem("token");
        localStorage.removeItem("refreshToken");
    }
}